/*
  CIZARO — Bag drawer enhancements (logic half of snippets/cizaro-cart-eta.liquid)

  Split out of the snippet on 17 Oct 2026 so neither half is large enough to
  trip the Admin API's payload ceiling on a theme-file write. All copy, the
  preorder handle list and the dispatch date arrive from #cz-eta-config, which
  the snippet renders from Liquid — nothing user-visible is hard-coded here.

  WHAT IT DOES
    1. Order -> Dispatch -> Delivery dates above the subtotal, for COD.
    2. Per-line sale pricing: struck compare-at price + -X% badge.
    3. "You save" total row, hidden when there is nothing to save.
    4. PREORDER awareness (audit CZ-003) — see below.

  PREORDER AWARENESS (audit CZ-003)
  The drawer was promising a 19-21 October delivery for a bag holding only a
  1-November preorder, while the cart PAGE showed the PREORDER badge and the
  real dispatch date. Three changes:
    a. Any preorder line in the bag replaces the three-stop timeline with the
       preorder panel, carrying the SAME sentence as the product page.
    b. Each preorder line gets the PREORDER pill + dispatch date, mirroring
       the cart page.
    c. Neither panel renders until the first cart read decides which applies.
       Ready-to-ship dates shown for 200ms then corrected are the same false
       promise, briefly.

  WHY INJECTED RATHER THAN HARD-CODED: two scripts rebuild this drawer (the
  header's renderCart(), and Shop The Look's refreshCart(), which replaces
  .cz-cart-drawer__inner wholesale), so everything re-applies on every cart
  event and via MutationObserver.

  compare_at_price is NOT in the cart.js line payload, so this fetches
  /products/<handle>.js once per unique product and caches it in a Map.

  NOT DONE HERE: the split-shipment sentence for a mixed bag (audit CZ-010).
  That is a fulfilment policy question and no assumption about it is made.
*/
(function () {
  if (window.__czCartEta) return;
  window.__czCartEta = 1;

  var cfgEl = document.getElementById('cz-eta-config');
  var tpl = document.getElementById('cz-eta-tpl');
  if (!cfgEl || !tpl) return;

  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var PROCESSING_DAYS = 1, ETA_MIN = 1, ETA_MAX = 3, CUTOFF_HOUR = 14;
  var TZ = CFG.tz;
  var MONEY_FMT = String(CFG.moneyFormat || '').replace(/<[^>]*>/g, '').trim();
  var PRE_SHIP_AT = new Date(CFG.preShipIso).getTime();

  var PRE = {};
  (CFG.preHandles || []).forEach(function (h) {
    h = String(h || '').trim().toLowerCase();
    if (h) PRE[h] = 1;
  });

  var node = tpl.content.firstElementChild.cloneNode(true);
  var saveRow = node.querySelector('[data-cz-save]');
  var saveAmt = node.querySelector('[data-cz-save-amt]');
  var etaRow = node.querySelector('[data-cz-eta]');
  var preRow = node.querySelector('[data-cz-pre]');

  /* null until the first cart read decides. Both panels stay hidden while it
     is null — see (c) above. */
  var isPreorderBag = null;
  var productCache = new Map();

  function money(cents) {
    if (window.CZCart && window.CZCart.formatMoney) return window.CZCart.formatMoney(cents);
    var two = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return MONEY_FMT.replace(/\{\{\s*amount[a-z_]*\s*\}\}/g, two);
  }

  function handleOf(item) {
    if (item.handle) return String(item.handle).toLowerCase();
    var m = String(item.url || '').split('?')[0].match(/\/products\/([^\/]+)/);
    return m ? m[1].toLowerCase() : null;
  }

  function isPreItem(item) {
    var h = handleOf(item);
    return !!(h && PRE[h]);
  }

  function rowFor(item) {
    return document.querySelector(
      '#cz-cart-drawer .cz-cart-drawer__item[data-cart-key="' + item.key + '"]'
    );
  }

  function getProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache.has(handle)) return Promise.resolve(productCache.get(handle));
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { productCache.set(handle, p); return p; })
      .catch(function () { productCache.set(handle, null); return null; });
  }

  /* Dates are computed in the SHOP's timezone so a shopper browsing from
     Riyadh still gets Cairo cut-off logic. */
  function shopNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hour12: false
      }).formatToParts(new Date());
      var o = {};
      parts.forEach(function (p) { o[p.type] = p.value; });
      return {
        date: new Date(o.year + '-' + o.month + '-' + o.day + 'T00:00:00'),
        minutes: parseInt(o.hour, 10) * 60 + parseInt(o.minute, 10)
      };
    } catch (e) {
      var d = new Date();
      return {
        date: new Date(d.getFullYear(), d.getMonth(), d.getDate()),
        minutes: d.getHours() * 60 + d.getMinutes()
      };
    }
  }

  function addDays(d, n) {
    var out = new Date(d.getTime());
    out.setDate(out.getDate() + n);
    return out;
  }

  function fmtDate(d) {
    try {
      return d.toLocaleDateString(document.documentElement.lang || 'en', {
        weekday: 'short', day: 'numeric', month: 'short'
      });
    } catch (e) { return d.toDateString(); }
  }

  /* [first, last] delivery day — keep in step with cz-bd11-pdp. */
  function deliveryRange(now) {
    var day = now.minutes > CUTOFF_HOUR * 60 ? addDays(now.date, 1) : now.date;
    var a = addDays(day, ETA_MIN), b = addDays(day, ETA_MAX), fri = false;
    for (var d = addDays(day, 1); d <= b; d = addDays(d, 1)) { if (d.getDay() === 5) fri = true; }
    if (fri) b = addDays(b, 1);
    if (a.getDay() === 5) a = addDays(a, 1);
    return [a, b];
  }

  function fmtRange(r) {
    try {
      var f = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {
        weekday: 'short', day: 'numeric', month: 'short'
      });
      if (f.formatRange) return f.formatRange(r[0], r[1]);
    } catch (e) {}
    return fmtDate(r[0]) + ' – ' + fmtDate(r[1]);
  }

  function compute() {
    var now = shopNow();
    /* Past the cut-off? The clock starts tomorrow. */
    var start = now.minutes > CUTOFF_HOUR * 60 ? addDays(now.date, 1) : now.date;
    var a = node.querySelector('[data-cz-eta-order]');
    var b = node.querySelector('[data-cz-eta-ship]');
    var c = node.querySelector('[data-cz-eta-deliver]');
    if (a) a.textContent = fmtDate(now.date);
    if (b) b.textContent = fmtDate(addDays(start, PROCESSING_DAYS));
    if (c) c.textContent = fmtRange(deliveryRange(now));
  }

  /* Which of the two panels the bag earns. Neither, while undecided. */
  function applyMode() {
    var shipped = !isNaN(PRE_SHIP_AT) && Date.now() >= PRE_SHIP_AT;

    if (isPreorderBag === null) {
      if (etaRow) etaRow.hidden = true;
      if (preRow) preRow.hidden = true;
      return;
    }

    if (isPreorderBag) {
      if (etaRow) etaRow.hidden = true;
      if (preRow) {
        var t = preRow.querySelector('[data-cz-pre-title]');
        var b = preRow.querySelector('[data-cz-pre-body]');
        /* After the window opens the date is in the past — say so rather than
           keep advertising it. Same rule as cz-preorder-flag. */
        if (t) t.textContent = shipped ? CFG.prePast : CFG.preTitle;
        if (b) { b.textContent = CFG.preBody; b.hidden = !!shipped; }
        preRow.hidden = false;
      }
      return;
    }

    if (preRow) preRow.hidden = true;
    if (etaRow) { compute(); etaRow.hidden = false; }
  }

  /* PREORDER pill + dispatch date on the line itself, mirroring the cart page.
     Per-line: a mixed bag marks only the preorder lines. */
  function markLine(item) {
    var row = rowFor(item);
    if (!row) return;
    var wrap = row.querySelector('.cz-cart-drawer__item-top > div');
    if (!wrap || wrap.querySelector('.cz-pre-pill')) return;

    var pill = document.createElement('span');
    pill.className = 'cz-pre-pill';
    pill.textContent = CFG.preLabel;
    wrap.appendChild(pill);

    var when = document.createElement('span');
    when.className = 'cz-pre-when';
    when.textContent = CFG.preLine;
    wrap.appendChild(when);
  }

  function decorate(cart) {
    if (!cart || !cart.items) return;

    /* Decide the panel before anything async — the timeline must never show
       for a preorder bag, not even for one frame. */
    isPreorderBag = cart.items.some(isPreItem);
    applyMode();
    cart.items.forEach(function (item) { if (isPreItem(item)) markLine(item); });

    Promise.all(cart.items.map(function (item) {
      return getProduct(handleOf(item)).then(function (p) {
        if (!p || !p.variants) return 0;
        var v = p.variants.filter(function (x) { return x.id === item.variant_id; })[0];
        if (!v || !v.compare_at_price || v.compare_at_price <= item.price) return 0;

        var row = rowFor(item);
        if (!row) return (v.compare_at_price - item.price) * item.quantity;

        var priceEl = row.querySelector('.cz-cart-drawer__item-price');
        if (priceEl && !priceEl.querySelector('.cz-was')) {
          var was = document.createElement('s');
          was.className = 'cz-was';
          was.textContent = money(v.compare_at_price * item.quantity);
          priceEl.insertBefore(was, priceEl.firstChild);
        }

        /* Percentage badge under the size. Target the TITLE wrapper — the first
           direct div of item-info is item-top, whose space-between flow pushed
           the badge out to the right of the remove button. */
        var wrap = row.querySelector('.cz-cart-drawer__item-top > div');
        if (wrap && !wrap.querySelector('.cz-off')) {
          var pct = Math.round((1 - item.price / v.compare_at_price) * 100);
          if (pct > 0) {
            var badge = document.createElement('span');
            badge.className = 'cz-off';
            badge.textContent = '−' + pct + '%';
            wrap.appendChild(badge);
          }
        }

        return (v.compare_at_price - item.price) * item.quantity;
      });
    })).then(function (amounts) {
      var compareSaved = amounts.reduce(function (a, b) { return a + b; }, 0);
      var discountSaved = 0;
      if (typeof cart.original_total_price === 'number' && typeof cart.total_price === 'number') {
        discountSaved = cart.original_total_price - cart.total_price;
      }
      var saved = compareSaved + Math.max(discountSaved, 0);

      if (saveRow && saveAmt) {
        if (saved > 0) {
          saveAmt.textContent = '−' + money(saved);
          saveRow.hidden = false;
        } else {
          saveRow.hidden = true;
        }
      }
    });
  }

  function pullCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(decorate)
      .catch(function () {});
  }

  function attach() {
    var foot = document.querySelector('#cz-cart-drawer [data-cz-cart-foot]')
      || document.querySelector('#cz-cart-drawer .cz-cart-drawer__foot');
    if (!foot) return;
    if (foot.firstElementChild === node) return;
    applyMode();
    foot.insertBefore(node, foot.firstChild);
  }

  function boot() {
    attach();
    pullCart();
    ['cz:cart', 'cart:update', 'cart:refresh', 'stl:added'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        setTimeout(attach, 0);
        var c = e && e.detail && e.detail.cart;
        if (c) setTimeout(function () { decorate(c); }, 0);
        else setTimeout(pullCart, 0);
      });
    });
    var inner = document.querySelector('#cz-cart-drawer .cz-cart-drawer__inner');
    if (inner && 'MutationObserver' in window) {
      new MutationObserver(function () { attach(); }).observe(inner, { childList: true, subtree: true });
    }
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) applyMode();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
